import axios from '@/axios';

export default {
  fetchAppUsers(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/fetchUserList?page=' +
            data.page +
            '&limit=' +
            data.limit +
            '&search=' +
            data.search +
            '&sort=' +
            data.sort +
            '&dir=' +
            data.dir +
            '&userType=' +
            data.userType +
            '&user=' +
            data.user
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchAppUserDetails(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/appUserDetails/' + id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchAppUserIndex() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/getUserIndex')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updateAppUserDetails(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/appUserDetails/update/' + data.id, data.info)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  saveAppUser(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/register', data.info)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  deleteAppUser(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/deleteUser/' + id)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  resetUserPassword(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/user/' + data.id + '/resetPassword', data.data)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },

  fetchAccountCreationLogs(_context, data) {
    return new Promise((resolve, reject) => {
      let fetchLogs =
        '/api/v1/accountCreationLogs?page=' +
        data.page +
        '&limit=' +
        data.limit +
        '&search=' +
        data.search +
        '&sort=' +
        data.sort +
        '&dir=' +
        data.dir +
        '&filter=' +
        data.filter;
   
      axios
        .get(fetchLogs)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          return reject(err);
        });
    });
  },
  getAccountCreationLogs(_context, data) {
    return axios
      .post('/api/v1/getCreationLogs', data)
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
  saveContactLogs(_context, data) {
    return axios
      .post('/api/v1/saveContactLogs', {
        userId: data.userId,
        name: data.name,
        orderId: data.orderId,
      })
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
  fetchContactAccountManagerLogs(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/contactAccountManagerLogs', { params: data })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchAccountManagers(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/accountManagers', { params: data })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAccountManagerDetails(_context, data) {
    return axios
      .post('/api/v1/accountManager', { data })
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
  fetchAllAccountManagerDetails() {
    return axios
      .get('/api/v1/getAllAccountManagers')
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
  saveAccountManagerDetails(_context, data) {
    return axios
      .post('/api/v1/saveAccountManager', data)
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
  updateAccountManagerDetails(_context, data) {
    return axios
      .post('/api/v1/updateAccountManager', data)
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
  deleteAccountManagerDetails(_context, id) {
    return axios
      .post('/api/v1/deleteAccountManager', {id})
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
  restoreAccountManagerDetails(_context, id) {
    return axios
      .post('/api/v1/restoreAccountManager', {id})
      .then(res => {
        return res.data; 
      })
      .catch(err => {
        throw err; 
      });
  },
};
